// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"8b76ae4c","380":"c4908d4b"}[chunkId] + ".chunk.js";
};